// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"98afc2c2","43":"343554de","160":"bb788f3e","208":"835bebc5","254":"1690de44","271":"f5a9fa6f","293":"6f631975","516":"4e42566c","519":"ff459837","630":"172ea80d","649":"2d7da940","910":"5e0fe72c","917":"bbc569f1","946":"6de82662"}[chunkId] + ".chunk.js";
};